import instance from "../../../connection/instance";
import { useState } from "react";
import { notifications } from '@mantine/notifications';

const usePlace = (t) => {
  const [place, setPlace] = useState();

  const upload = async (file) => {
    const { data } = await instance.post('/api/image/upload', { file }, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });

    if (data.errors?.length > 0) {
      return { errors: data.errors }
    }

    return data
  }

  const fetch = async (id) => {
    const { data: { response, errors: fetchErrors }} = await instance.get(`/api/place/${id}`);

    if (fetchErrors?.length > 0) {
      return { errors: fetchErrors }
    }

    setPlace(response);
  }

  const update = async (id, formData, vip, place, isSave) => {
    let image = null
    let logo = null

    const imageErrors = [];

    if (formData.image) {
      const fetchedData = await upload(formData.image)

      if (fetchedData.errors) {
        imageErrors.push(0);
        
        fetchedData.errors.forEach(error => {
          switch (error.code) {
            case 'P050':
              notifications.show({
                title: t('notifications.place.image.commonError'),
                autoClose: 2000
              });
  
              break;
  
            default:
              notifications.show({
                title: t('notifications.place.image.error'),
                autoClose: 2000
              });

              break;
          }
        })
      } else {
        image = fetchedData
      }
    }

    if (formData.logo) {
      const fetchedData = await upload(formData.logo)

      if (fetchedData.errors) {
        imageErrors.push(0);

        fetchedData.errors.forEach(error => {
          switch (error.code) {
            case 'P050':
              notifications.show({
                title: t('notifications.place.image.commonError'),
                autoClose: 2000
              });
  
              break;
  
            default:
              notifications.show({
                title: t('notifications.place.logo.error'),
                autoClose: 2000
              });

              break;
          }
        })
      } else {
        logo = fetchedData
      }
    }
    
    const mappedData = {
      place: {
        placeKey: place.place.placeKey,
        placeName: formData.placeName,
        placeAddress: formData.placeAddress,
        vip,
        image,
        logo,
        type: formData.type
      },
      info: {
        placeKey: place.place.placeKey,
        schedule: formData.schedule,
        phone: formData.phone,
        social: formData.social,
        description: formData.description,
        site: formData.site,
        copyright: formData.copyright
      },
    }

    const { data: { response, errors } } = await instance.post(`/api/place/${id}`, { ...mappedData });

    if (errors?.length > 0 || imageErrors.length > 0) {
      [...errors, ...imageErrors].forEach(error => {
        switch (error.code) {
          case 'P050':
            notifications.show({
              title: t('notifications.permissionError'),
              autoClose: 2000
            });

            break;

          default:
            notifications.show({
              title: t('notifications.place.error'),
              autoClose: 2000
            });
            break;
        }
      })

      return { errors }
    }

    if (isSave) {
      notifications.show({
        title: t('notifications.place.save'),
        autoClose: 2000
      });
    } else {
      notifications.show({
        title: vip ? t('notifications.place.publish') : t('notifications.place.unpublish'),
        autoClose: 2000
      });
    }

    setPlace(response);

    return response;
  }

  return [
    {
      place
    },
    {
      fetch,
      update
    }
  ]
}

export default usePlace;
